import { render, staticRenderFns } from "./WeightInput.vue?vue&type=template&id=158012c5&"
import script from "./WeightInput.vue?vue&type=script&lang=js&"
export * from "./WeightInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports